function CanchasManager({
  canchas,
  editandoId,
  nombreEditando,
  valorHoraEditando,
  onStartEdit,
  onChangeEdit,
  onChangeValorHoraEdit,
  onSaveEdit,
  onCancelEdit,
  onDelete,
}) {
  // separar padres e hijas
const padres = canchas.filter((c) => !c.parent_cancha_id);
const hijas = canchas.filter((c) => c.parent_cancha_id);

const obtenerHijas = (padreId) => {
  return hijas.filter((h) => h.parent_cancha_id === padreId).sort((a, b) => a.nombre.localeCompare(b.nombre));
};
const tieneHijas = (id) => hijas.some(h => h.parent_cancha_id === id);

  return (
    <article className="panel">
      <div className="section-title">
        <h2>Canchas registradas</h2>
        <span>{canchas.length} elementos</span>
      </div>

      <div className="list-stack">
        {canchas.length === 0 ? <p>No hay canchas registradas.</p> : null}

        {padres.map((padre) => (
          <div key={padre.id} style={{ marginBottom: 20 }}>
            
            {/* 🔷 PADRE */}
            <div className="list-item">
              {editandoId === padre.id ? (
                <>
                  <input
                    className="inline-input"
                    value={nombreEditando}
                    onChange={(e) => onChangeEdit(e.target.value)}
                  />
                  <input
                    className="inline-input"
                    type="number"
                    min="1"
                    step="0.01"
                    value={valorHoraEditando}
                    onChange={(e) => onChangeValorHoraEdit(e.target.value)}
                  />
                  <div className="item-actions inline-actions">
                    <button className="secondary-button" onClick={() => onSaveEdit(padre.id)}>
                      Guardar
                    </button>
                    <button className="secondary-button" onClick={onCancelEdit}>
                      Cancelar
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <strong>{padre.nombre}</strong>
                  <span>${Number(padre.valor_hora || 0).toFixed(2)} / hora</span>
                  <div className="item-actions inline-actions">
                    <button className="secondary-button edit-action" onClick={() => onStartEdit(padre)}>
                      Editar
                    </button>
                    <button
  className="secondary-button danger"
  onClick={() => {
    if (tieneHijas(padre.id)) {
      alert("No puedes eliminar una cancha que tiene subcanchas");
      return;
    }
    onDelete(padre.id);
  }}
>
  Eliminar
</button>
                  </div>
                </>
              )}
            </div>

            {/* 🔹 HIJAS */}
            <div style={{ marginLeft: 25 }}>
              {obtenerHijas(padre.id).map((hija) => (
                <div className="list-item" key={hija.id} style={{ marginTop: 10 }}>
                  {editandoId === hija.id ? (
                    <>
                      <input
                        className="inline-input"
                        value={nombreEditando}
                        onChange={(e) => onChangeEdit(e.target.value)}
                      />
                      <input
                        className="inline-input"
                        type="number"
                        min="1"
                        step="0.01"
                        value={valorHoraEditando}
                        onChange={(e) => onChangeValorHoraEdit(e.target.value)}
                      />
                      <div className="item-actions inline-actions">
                        <button className="secondary-button" onClick={() => onSaveEdit(hija.id)}>
                          Guardar
                        </button>
                        <button className="secondary-button" onClick={onCancelEdit}>
                          Cancelar
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <strong>└─ {hija.nombre}</strong>
                      <span>${Number(hija.valor_hora || 0).toFixed(2)} / hora</span>
                      <div className="item-actions inline-actions">
                        <button className="secondary-button edit-action" onClick={() => onStartEdit(hija)}>
                          Editar
                        </button>
                        <button className="secondary-button danger" onClick={() => onDelete(hija.id)}>
                          Eliminar
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>

          </div>
        ))}
      </div>
    </article>
  );
}

export default CanchasManager;